// Champs éditables transverses : navigation et pied de page.

export const SITE_FIELDS = [
  { key: "nav.accueil", label: "Menu mobile : Accueil", def: "Accueil" },
  { key: "nav.eugenie", label: "Menu : Eugénie", def: "Eugénie" },
  { key: "nav.clinique", label: "Menu : Clinique", def: "Clinique" },
  { key: "nav.conversations", label: "Menu : Conversations", def: "Conversations" },
  { key: "nav.medias", label: "Menu : Médias", def: "Médias" },
  { key: "nav.conferences", label: "Menu : Conférences", def: "Conférences" },
  { key: "nav.projets", label: "Menu : Projets", def: "Projets" },
  { key: "nav.contact", label: "Menu : Contact", def: "Contact" },
  { key: "nav.cta", label: "Bouton « On peut en parler » (menu)", def: "On peut en parler" },

  { key: "footer.sous-titre", label: "Pied de page : sous-titre du logo", def: "Entrepreneure à impact social · Vulgarisatrice" },
  { key: "footer.nav.titre", label: "Pied de page : titre colonne navigation", def: "Navigation" },
  { key: "footer.quick.titre", label: "Pied de page : titre colonne liens rapides", def: "Liens rapides" },
  { key: "footer.contact.titre", label: "Pied de page : titre colonne contact", def: "On peut en parler" },
  { key: "footer.contact.texte", label: "Pied de page : texte d'invitation", def: "Une question, une invitation, une idée de collaboration ?" },
  { key: "footer.contact.cta", label: "Pied de page : bouton", def: "Écrire à Eugénie" },
  { key: "footer.signature", label: "Pied de page : phrase manuscrite", type: "long", def: "Parler de sexualité avec sincérité, douceur, rigueur et humanité." },
  { key: "footer.quick.ressources", label: "Liens rapides : Ressources d'aide", def: "Ressources d'aide" },
  { key: "footer.quick.confidentialite", label: "Liens rapides : Politique de confidentialité", def: "Politique de confidentialité" },
  { key: "footer.quick.mentions", label: "Liens rapides : Mentions légales", def: "Mentions légales" },
  { key: "footer.quick.medias", label: "Liens rapides : Espace médias", def: "Espace médias" },
];
